// extracted by mini-css-extract-plugin
export default {"wrap":"ElecRecord_wrap__cb8G3","top":"ElecRecord_top__aPrZK","export":"ElecRecord_export__4Vwz1"};